export const GET_COURTS_LIST = 'GET_COURTS_LIST';
export const GET_COURTS_LIST_SUCCESS = 'GET_COURTS_LIST_SUCCESS';
export const GET_COURTS_LIST_FAIL = 'GET_COURTS_LIST_FAIL';
